<script lang="ts">
    export let show:boolean = false
    let clazz:string | null = null;
	  export { clazz as class };
    let dialog:HTMLDialogElement
    $: {
      if (dialog && show != dialog.open) {
        if (show) {
          dialog.showModal();
        }
        else {
          dialog.close();
        }
      }
    }
</script>

<dialog bind:this={dialog} class={`dialog bg-darkBack ${clazz || ''}`}>
  <slot/>
</dialog>

<style>
  .dialog::backdrop {
    @apply backdrop-filter;
    @apply backdrop-blur-sm;
    background: rgba(0, 0, 0, 0.5);
  }
</style>